<template>
    <div class="omocom-insurance-accordion">
        <div class="vehicle-insurance__insurance-by">
            <span>{{ $t('common.by') }}</span>
            <InsuranceLogo class="insurance-logo--omocom" :vendor="vehicle.insuranceVendor" />
        </div>
        <p class="omocom-insurance-accordion__description">{{ $t('pages.vehicle.info_about_omocom') }}</p>

        <p class="omocom-insurance-accordion__subtitle">{{ $t('pages.vehicle.addon_included_in_price') }}</p>
        <OmocomBasicInsuranceNotice
            :product="omocomBasicProduct"
            :is-interior-insurance-included="isInteriorInsuranceIncluded"
        />

        <p class="omocom-insurance-accordion__subtitle">{{ $t('pages.vehicle.optional_insurances') }}</p>
        <OmocomOptionalInsurance :product-key="OMOCOM_COMPLETE" :omocom-coverage-products="coverageProducts" />
        <OmocomOptionalInsurance
            v-if="travelAbroadProduct"
            :product-key="travelAbroadProduct.key"
            :vehicle-country="vehicle.country"
            :product="travelAbroadProduct"
        />
        <OmocomOptionalInsurance
            v-if="youngDriverProduct"
            :product-key="youngDriverProduct.key"
            :product="youngDriverProduct"
        />
    </div>
</template>

<script>
import { INSURANCE_ADDON, OMOCOM_BASIC, OMOCOM_COMPLETE, OMOCOM_PACKAGES } from '~/config/productTypes';
import InsuranceLogo from '~/components/InsuranceLogo';
import OmocomBasicInsuranceNotice from '~/components/booking/OmocomBasicInsuranceNotice';
import OmocomOptionalInsurance from '~/components/booking/OmocomOptionalInsurance';

export default {
    name: 'OmocomInsuranceOptions',
    components: {
        OmocomOptionalInsurance,
        OmocomBasicInsuranceNotice,
        InsuranceLogo,
    },
    props: {
        vehicle: {
            type: Object,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        isInteriorInsuranceIncluded: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            OMOCOM_COMPLETE,
            INSURANCE_ADDON,
        };
    },
    computed: {
        coverageProducts() {
            return this.items.filter(item => OMOCOM_PACKAGES.includes(item.key));
        },
        omocomBasicProduct() {
            return this.items.find(item => item.key === OMOCOM_BASIC);
        },
        travelAbroadProduct() {
            return this.items.find(item => item.key === INSURANCE_ADDON.travel_abroad);
        },
        youngDriverProduct() {
            return this.items.find(item => item.key === INSURANCE_ADDON.young_driver);
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/_variables.scss';

.omocom-insurance-accordion {
    &__subtitle {
        @include font-size(14px);
        margin-bottom: 8px;
        font-weight: 600;
    }

    &__description {
        @include font-size(14px);
        margin-bottom: 24px;
    }

    .omocom-basic-insurance {
        margin-bottom: 16px;
    }

    .omocom-optional-insurance:not(:last-child) {
        margin-bottom: 8px;
    }
}
</style>
